import * as R from 'ramda';
import { requestWithAuthorization } from './requestWithAuthorization';
import portalConfigure from '@/portal-configure';
import {
  ScheduledEventMetadataWithDetailForFront,
  ErrorInfo,
  LoginInfo,
} from '@/types/type';
import { UserAction } from '@/utils/consts';

export const changeTodayScheduledEvents = async (
  loginInfo: LoginInfo,
  dbEventMetadata: ScheduledEventMetadataWithDetailForFront | null,
  currentEventMetadata: ScheduledEventMetadataWithDetailForFront,
  userAction: UserAction,
  timezoneOffset: number
) => {
  await requestWithAuthorization
    .post(`${portalConfigure.API.changeTodayScheduledEvents}`, {
      loginInfo,
      dbEventMetadata,
      currentEventMetadata,
      userAction,
      timezoneOffset,
    })
    .catch(error => {
      const data = R.path(['response', 'data'], error);
      if (data) {
        error.message = JSON.stringify(data);
      } else {
        const dbEventMetadataVariables = dbEventMetadata
          ? `[dbEventMetadata] rruleSet:${dbEventMetadata.rruleSet}, holidayExecutionType:${dbEventMetadata.holidayExecutionType}, triggerOnHolidays:${dbEventMetadata.triggerOnHolidays}, customHolidayLabels:${dbEventMetadata.customHolidayLabels}`
          : '[dbEventMetadata] No data passed';
        const currentEventMetadataVariables = `[currentEventMetadata] rruleSet:${currentEventMetadata.rruleSet}, holidayExecutionType:${currentEventMetadata.holidayExecutionType}, triggerOnHolidays:${currentEventMetadata.triggerOnHolidays}, customHolidayLabels:${currentEventMetadata.customHolidayLabels}`;
        const errorInfo: ErrorInfo = {
          code: 'E00011',
          title: `Error in passing eventMetadata info. [eventMetadata ID] ${currentEventMetadata.id}, ${dbEventMetadataVariables}, ${currentEventMetadataVariables}`,
          message: error.message,
        };
        error.message = JSON.stringify(errorInfo);
      }
      throw error;
    });
};
